<a
  [href]="href || '#'"
  (click)="onClick($event)"
  [class]="cssClass"
  class="inline-flex items-center gap-2 font-semibold text-blue"
>
  <span>{{ description }}</span>
  <ng-content />
</a>
